/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getDiscovery} from '../api'

 export const useQueryGetDiscovery = createReactQueryHook('getDiscovery', getDiscovery)
